@import '../../global/utility/responsive/responsive-mixins';

/* stylelint-disable declaration-no-important */
// resonsive behaviour
$sizes: 400, 100;

:host {
  @include responsive($sizes);

  position: relative;

  .ui-video {
    &__copyright {
      @extend %caption;

      color: $ui-grey-plus-1;
      margin-top: 11px;

      .container--bg-dark-blue & {
        color: $ui-white;
      }
    }

    &__holder {
      margin: 0;
      padding: 0;
    }

    &__wrapper {
      position: relative;

      video {
        width: 100%;
      }
    }

    &__error {
      display: flex;
      align-items: center;
      justify-content: center;

      &-text {
        display: block;
        padding-left: 0.5rem;
        font-size: 1rem;
      }
    }

    &-overlay {
      cursor: pointer;
      position: absolute;
      background: transparent;
      top: 0;
      bottom: 5px;
      left: 0;
      right: 0;

      &--dark {
        background: rgba(0 0 0 / 65%);
      }

      &--icon {
        position: relative;
        background-color: rgba($ui-white, 0.8);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        height: 3.35rem;
        width: 3.35rem;

        @include breakpoint($small) {
          height: 6rem;
          width: 6rem;
        }

        ui-icon {
          height: 2rem;
          width: 2rem;
          left: 0.85rem;
          top: 0.7rem;
          position: absolute;

          @include breakpoint($small) {
            height: 3.75rem;
            width: 3.75rem;
            left: 1.45rem;
            top: 1.2rem;
          }
        }
      }
    }
  }
}
